import { appFormUtil } from 'modules/common';
import React from 'react';
import * as ds from './dataService';
import { StyledDropDown } from 'modules/components/layer01';


export type DeliveryInstallationSelectFieldProps<T extends object, K extends keyof T = keyof T> = {
  projectId: string;
  form: appFormUtil.InferReturn<T>;
  fieldName: K;

};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = <T extends object>(props: DeliveryInstallationSelectFieldProps<T>) => {
  const { data } = ds.useQuery(props.projectId);
  return (
    <StyledDropDown.FC
      options={data}
      {...props.form.genFieldProps(props.fieldName)}
    />
  );
};
